import Icon from "@client/controls/Icon/component";
import { IconType } from "@client/types";
import classNames from "classnames";
import React from "react";

import "./style.less";

export type MapProps = {
  className?: string;
  color: string;
  itemCount: number;
  isEditMode: boolean;
};
export type ActionProps = {
  goToCart: () => void;
};
export default (props: ActionProps & MapProps) => (
  <div className={classNames("cart_item", props.className)} onClick={props.isEditMode ? undefined : props.goToCart}>
    <Icon iconClassName={IconType.ShoppingCart} />
    {!!props.itemCount && (
      <span className="count" style={{ "--color": props.color } as any}>
        {props.itemCount > 9 ? `9+` : props.itemCount}
      </span>
    )}
  </div>
);
